import faker from 'faker';
import { sum } from 'lodash';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  Stack,
  Button,
  TextField,
  OutlinedInput,
  Tooltip,
  Paper
} from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { fCurrency } from 'src/utils/formatNumber';
import Page from 'src/components/Page';
import Scrollbar from 'src/components/Scrollbar';
import { LoadingButton } from '@material-ui/lab';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { empty } from 'src/Helpers/Common';
import { forwardRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useTheme } from '@emotion/react';
import useCompanyProfile from 'src/hooks/useCompanyProfile';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { Print } from "@material-ui/icons";
import { GetApp } from "@material-ui/icons";
import JobCostChartSignwise from 'src/components/charts/JobCostChartSignwise';
import JobCostNotesPage from 'src/components/charts/JobCostNotesPage';



// Styled Components
const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

export default function CompareJobCostChartMain({ id, tmLabel, logs, setLogs, fetchJobCostLogs, requestId}) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedProjects1, setSelectedProjects1] = useState([]);
  const [materialPayOut, setMaterialPayOut] = useState(0);
  const [materialPayOut1, setMaterialPayOut1] = useState(0);
  const [manualTotalPayOut, setManualTotalPayOut] = useState(0);
  const [hourlyTotalPayOut, setHourlyTotalPayOut] = useState(0);
  const [excessHourlyPayoutAmount, setExcessHourlyPayoutAmount] = useState(0)
  const [excessManualPayoutAmount, setExcessManualPayoutAmount] = useState(0)
  const [additionalServices, setAdditionalServices] = useState([])
  const [projectData, setProjectData] = useState([])
  const [recipe, setRecipe] = useState([])
  // const [services, setServices] = useState([]);
  const [services, setAllServices] = useState([]);
  const [stockProducts, setStockProducts] = useState([])
  const [jobCost, setJobCost] = useState(0);
  const [loading, setLoading] = useState(false);
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [productList, setProductList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const params = localStorage.getItem("params") || requestId
  const user = JSON.parse(window.localStorage.getItem('user'))

  const [data, setData] = useState({});
  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(...res.data.data);
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  const fetchData = () => {
    try {
      setLoading(true)
      axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`,
        { userId: user.user_id, userType: user.user_type, projectId: id, orderId: requestId }).then((response) => {
          const productListData = response.data.results
          let selectedProducts = response.data.selectedMaterials
          let receivedRfpProducts = selectedProducts.filter(row => row.rfp === 1)
          let rfpProducts = receivedRfpProducts.map(product => ({
            ...product,
            jobcost_unit_cost: product.unit_cost,
            jobcost_quantity: product.quantity,
            jobcost_actual_unit_cost: product.actual_unit_cost,
            jobcost_actual_quantity: product.actual_quantity
          }));
          selectedProducts = selectedProducts.filter(row => row.rfp === 0)
          let initialData = response.data.selectedMaterials
          const allPayouts = response.data.allPayOut
          const project = response.data.projects
          const allMaterials = response.data.allMaterials
          const allRecipes = response.data.allRecipies
          const material = response.data.materials
          let allServices = response.data.allServices
          let stockProducts = response?.data?.stockProducts
          let additionalServices = response.data.additionalServices
          if (additionalServices) {
            setAdditionalServices(additionalServices.reduce((accumulator, currentValue) => {
              return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
            }, 0))
          }
          if (project) {
            setProjectData(project)
          }
          if (allRecipes) {
            setRecipe(allRecipes)
          }
          if (material?.length > 0) {
            setMaterialPayOut(
              material
                ?.filter(curr => curr.notFromRecipe != true)
                .reduce((acc, curr) => acc + curr.actual_total, 0)
            );

            setMaterialPayOut1(
              material
                ?.filter(curr => curr.notFromRecipe == true)
                .reduce((acc, curr) => acc + curr.total, 0)
            );
          }
          if (allServices) {
            setAllServices(allServices)
          }
          if (stockProducts) {
            setStockProducts(stockProducts)
          }
          if (allPayouts?.length > 0) {
            let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
            const totalHourlyPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay === 1 && !payout.service_id)?.reduce((acc, curr) => acc + curr.amount, 0);
            setExcessHourlyPayoutAmount(totalHourlyPayoutAmount)
            const totalManualPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay !== 1 && !payout.service_id)?.reduce((acc, curr) => acc + curr.amount, 0);
            setExcessManualPayoutAmount(totalManualPayoutAmount)

            const summedHourlyPayouts = Object.values(
              allPayouts?.filter(payout => payout.is_auto_pay === 1)?.reduce((acc, payout) => {
                const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;

                if (!acc[key]) {
                  acc[key] = {
                    project_id: payout.project_id,
                    task_id: payout.task_id,
                    team: payout.team,
                    total_amount: 0,
                  };
                }

                acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));

                return acc;
              }, {})
            );

            console.log('summedHourlyPayouts===', summedHourlyPayouts);

            const summedManualPayouts = Object.values(
              allPayouts?.filter(payout => payout.is_auto_pay !== 1)?.reduce((acc, payout) => {
                const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;

                if (!acc[key]) {
                  acc[key] = {
                    project_id: payout.project_id,
                    task_id: payout.task_id,
                    team: payout.team,
                    total_amount: 0,
                  };
                }

                acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));

                return acc;
              }, {})
            );

            console.log('summedManualPayouts===', summedManualPayouts);

            setHourlyTotalPayOut(summedHourlyPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
            setManualTotalPayOut(summedManualPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          }
          if (initialData) {
            setInitialMaterials(initialData)
          }
          if (productListData) {
            setProductList(productListData)
          }
          if (allMaterials) {
            setMaterialList(allMaterials)
          }
          if (project) {
            setJobCost(project.cost || 0)
          }
          if (selectedProducts?.length > 0 || material?.length > 0) {
            const selectedProjects1 = selectedProducts?.map(selectedProduct => {
              const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
              if (matchingProduct) {
                return {
                  ...matchingProduct,
                  product_id: selectedProduct.product_id,
                  jobcost_quantity: selectedProduct.quantity,
                  jobcost_unit_cost: selectedProduct.unit_price,
                  jobcost_total: selectedProduct.total,
                  jobcost_actual_quantity: selectedProduct.actual_quantity,
                  jobcost_actual_unit_cost: selectedProduct.actual_unit_price,
                  recipeName: selectedProduct.recipeName,
                  taken: selectedProduct.taken,
                  task_id: selectedProduct.task_id
                };
              }
              return null; // Handle cases where no matching product is found
            }).filter(project => project !== null);
            const selectedProjects2 = material?.map(selectedProduct => {
              const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
              if (matchingProduct) {
                return {
                  ...matchingProduct,
                  product_id: selectedProduct.product_id,
                  jobcost_quantity: selectedProduct.quantity,
                  jobcost_unit_cost: selectedProduct.unit_price,
                  jobcost_total: selectedProduct.total,
                  jobcost_actual_quantity: selectedProduct.actual_quantity,
                  jobcost_actual_unit_cost: selectedProduct.actual_unit_price,
                  recipeName: selectedProduct.recipeName,
                  taken: selectedProduct.taken,
                  task_id: selectedProduct.task_id
                };
              }
              return null; // Handle cases where no matching product is found
            }).filter(project => project !== null);
            setSelectedProjects([...selectedProjects1, ...rfpProducts]);
            setSelectedProjects1([...selectedProjects2]);

            const materialPayOut = selectedProjects2
              ?.filter(curr => curr.notFromRecipe != true)
              .reduce((acc, curr) => acc + curr.jobcost_actual_quantity * curr.jobcost_actual_unit_cost, 0);

            const materialPayOut1 = selectedProjects2
              ?.filter(curr => curr.notFromRecipe != true)
              .reduce((acc, curr) => acc + curr.jobcost_total, 0);

            console.log('Material PayOut (Not From Recipe):', materialPayOut);
            console.log('Material PayOut1 (From Recipe):', materialPayOut1);

            setMaterialPayOut(materialPayOut);
            setMaterialPayOut1(materialPayOut1);

          }
        })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 500);
    }
  }

  useEffect(() => {
    if(requestId){
      console.log("sdfsdfsfd",requestId)
      fetchData()
    }
    fetchDetails()
  }, [id, requestId]);

  const totalStockCost = useMemo(() => (
    stockProducts.reduce((sum, item) => {
      const cost = parseFloat(item.location_quantity || 0) * parseFloat(item.product_retail_price || 0);
      return sum + cost;
    }, 0)
  ), [stockProducts]);
  console.log('totalStockCosttotalStockCost 1', totalStockCost)

  const totalStockCost1 = useMemo(() => (
    stockProducts.reduce((sum, item) => {
      if (item?.taken !== 1) return sum;

      const cost = parseFloat(item.jobcost_total_cost || 0);
      return sum + cost;
    }, 0)
  ), [stockProducts]);
  console.log('totalStockCosttotalStockCost 2', totalStockCost1)

  const grandTotalCost = useMemo(() => {
    const selectedProjectsCost = selectedProjects.reduce(
      (acc, proj) => {
        const totalCost = proj.jobcost_total
          ? Number(proj.jobcost_total)
          : (Number(proj.jobcost_actual_unit_cost || proj.unit_cost || 0) * Number(proj.jobcost_actual_quantity || 0));

        return acc + totalCost;
      }, 0
    );
    const servicesCost = services.reduce((sum, service) => {
      // if (service.recipe_id == null) {
      const quantity = parseFloat(service.qty || 0);
      const unitCost = parseFloat(service.originalCost || service.unit_cost || 0);
      return sum + (quantity * unitCost);
      // }
      return sum;
    }, 0);
    return (
      materialPayOut +
      selectedProjectsCost +
      servicesCost +
      totalStockCost
    );
  }, [selectedProjects, services, materialPayOut, manualTotalPayOut, hourlyTotalPayOut,totalStockCost]);

  const grandTotalCost1 = useMemo(() => {
    const selectedProjectsCost = selectedProjects?.filter(i => i.taken == 1)?.reduce(
      (acc, proj) => acc + proj.jobcost_total,
      0
    );

    const servicesCost = services.reduce((sum, service) => {
      if (projectData?.job_category_name === 'Time & Material') {
        if (service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
        }
      } else {
        if (service.taken == 1) {
          return sum + parseFloat(service.jobcost_total_cost || 0);
        }
      }
      return sum;
    }, 0);

    console.log('grandtotal1==materialPayOut1==', materialPayOut1)
    console.log('grandtotal1==selectedProjectsCost==', selectedProjectsCost)
    console.log('grandtotal1==servicesCost==', servicesCost)
    console.log('grandtotal1==manualTotalPayOut==', manualTotalPayOut)
    console.log('grandtotal1==hourlyTotalPayOut==', hourlyTotalPayOut)
    const additionalAmount = ((excessManualPayoutAmount || 0) + (excessHourlyPayoutAmount || 0)) || 0
    console.log('grandtotal1==additionalAmount==', additionalAmount)
    return (
      materialPayOut1 +
      selectedProjectsCost +
      servicesCost +
      totalStockCost1 +
      Math.max(0, additionalAmount)
    );
  }, [selectedProjects, services, materialPayOut1, manualTotalPayOut, hourlyTotalPayOut,totalStockCost1]);

  return (
    <Page title="Job Calculator">
      <Grid container spacing={2} direction={{ xs: 'column', md: 'row' }} sx={{ mb: 3.5 }}>
        <Grid item xs={12} md={6}>
          <Paper variant='outlined' sx={{ p: 1 }}>
            <JobCostChartSignwise
              actualSeries={[
                parseFloat(0),
                grandTotalCost1,
              ]}
              expectedSeries={[
                parseFloat(0),
                grandTotalCost,
              ]}
              actualTotal={grandTotalCost1}
              expectedTotal={grandTotalCost}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper variant='outlined' sx={{ p: 1 }}>
            <JobCostNotesPage
              logs={logs}
              projectData={projectData}
              setLogs={setLogs}
              fetchJobCostLogs={fetchJobCostLogs}
              requestId={requestId}
            />
          </Paper>
        </Grid>
      </Grid>
    </Page>
  );
}